import { UsersSearchColumn } from '../components/UsersSearchColumn';
import { DevicesSearchColumn } from '../components/DevicesSearchColumn';

export function CustomersPage() {
  return (
    <div className="flex flex-col gap-6 p-6" data-testid="customers-page">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-bold text-foreground">{'Customers'}</h1>
        <p className="text-sm text-muted-foreground">
          {'Search users by email or domain, or devices by name or UUID.'}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <UsersSearchColumn />
        <DevicesSearchColumn />
      </div>
    </div>
  );
}
